import Tooltip from '@dealroadshow/uikit-tooltip';
import { useSectorContext } from '@dm-portal/sector/SectorContext';
import { useIndustryContext } from "../../../contexts/IndustryContext";
import { IDataroomListItem } from "../../../domain/vo/DataroomListItem";
import styles from '../../Set/set.module.scss';

interface IProps {
  cellProps: {
    row: IDataroomListItem,
  },
}

const SectorCell = ({ cellProps: { row } }: IProps) => {
  const { subSectorList } = useSectorContext();
  const { subIndustryList } = useIndustryContext();

  const {
    subsectorId,
    subindustryId,
  } = row;
  let abbreviation!: string;
  let color!: string;
  let tooltip!: string;

  if (subSectorList.size === 0 || subIndustryList.size === 0) {
    return null;
  }

  if (!subsectorId && !subindustryId) {
    return null;
  }

  if (subsectorId) {
    const sector = subSectorList.get(subsectorId)!;
    abbreviation = sector.sectorAbbreviation;
    color = sector.sectorColor;
    tooltip = `${ sector.sectorName }: ${ sector.subSectorName }`;
  } else if (subindustryId) {
    const industry = subIndustryList.get(subindustryId)!;
    abbreviation = industry.industryAbbreviation;
    color = industry.industryColor;
    tooltip = `${ industry.industryName }: ${ industry.subIndustryName }`;
  }
  return (
    <Tooltip
      placement="bottom"
      content={ tooltip }
      className={ styles.hideTooltipOnMobile }
      usePortal={ false }
    >
      <span
        style={ { backgroundColor: `${ color }` } }
        className={ styles.sector }
      >
        { abbreviation }
      </span>
    </Tooltip>
  );
};

export default SectorCell;
